import dayjs from 'dayjs';
import { isUndefined } from '@/utils/api';
import { useQuestionCommon } from '@rebuild/materials/shared/question/useQuestionCommon';

export const useQuestionDisplayUtils = () => {
	const { CODE_FILTER_NAME } = useQuestionCommon();

	const getSourceBizText = item => {
		const sourceBiz = item?.sourceBiz;
		return isUndefined(sourceBiz) ? '' : `${CODE_FILTER_NAME[sourceBiz]}`;
	};

	const getQuestionTimeText = item => {
		const questionTime = item?.questionTime;
		if (!questionTime) return '';
		return dayjs(questionTime).format('YYYY-MM-DD');
	};

	return {
		getSourceBizText,
		getQuestionTimeText
	};
};
